import * as service from './service'
export default {
  namespace: 'recruitMyInfo',
  state: {
    hotLineData: {},
    queryMobileInfoData: {}
  },
  effects: {
    * getHotLine ({ payload }, { call, put }) {
      const res = yield call(service.getHotLine, payload)
      yield put({
        type: 'save',
        payload: {
          hotLineData: res.data
        }
      })
      return res.data
    },
    * queryMobileInfo ({ payload }, { call, put }) {
      const res = yield call(service.queryMobileInfo, payload)
      yield put({
        type: 'save',
        payload: {
          queryMobileInfoData: res.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
